// @flow
import React, { Component } from "react";
import Map from "./Map/Map";
import NewsStory from "./NewsStory/NewsStory";
import container from "../../../styles/container.module.css";
import styles from "./BreachNews.module.css";

type Props = {
  location: PrismicLocation,
  stories: Array<BreachStory>
};

type State = {};

class BreachNews extends Component<Props, State> {
  render() {
    const { location, stories } = this.props;
    return (
      <div className={styles.wrapper}>
        <Map {...location} />
        <div className={styles.newsWrapper}>
          <div className={`${styles.stories} ${container.default}`}>
            {stories.map((story: BreachStory) => (
              <NewsStory key={story.url.url} story={story} />
            ))}
            <div className={styles.timeline} />
          </div>
        </div>
      </div>
    );
  }
}

export default BreachNews;



// WEBPACK FOOTER //
// ./src/components/Breach/BreachNews/BreachNews.js